module.exports = __webpack_public_path__ + "static/img/back_in_time_system.d6a300b2.png";